
// import { useState } from "react";
// import { PhotoIcon } from "@heroicons/react/24/outline";
// import Sidebar from "../components/Sidebar";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// export default function Form() {
//   const [title, setTitle] = useState("");
//   const [content, setContent] = useState("");
//   const [files, setFiles] = useState(null);

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFiles(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const newBlog = {
//       title,
//       content,
//       files,
//       date: new Date().toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "short",
//         day: "numeric",
//       }),
//     };
//     console.log(newBlog)
//   };

//   return (
//     <Sidebar>
//       <div className="page-header">
//         <h1 className="page-title">Add New Blog</h1>
//       </div>

//       <div className="card">
//         <form onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label className="form-label">Blog Title</label>
//             <input
//               type="text"
//               className="input-text"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               placeholder="Enter an awesome title..."
//               required
//             />
//           </div>

//           <div className="form-group">
//             <label className="form-label">Featured Image</label>

//             <div className={`image-upload-box ${files ? "image-has-preview" : ""}`}>
//               {files ? (
//                 <div className="image-preview-wrapper">
//                   <img src={files} alt="Featured" className="image-preview" />
//                   <button
//                     type="button"
//                     onClick={() => setFiles(null)}
//                     className="image-remove-btn"
//                   >
//                     X
//                   </button>
//                 </div>
//               ) : (
//                 <>
//                   <PhotoIcon className="upload-icon" />
//                   <p className="upload-text">Click to upload featured image</p>
//                   <input
//                     type="file"
//                     multiple
//                     accept="image/*"
//                     onChange={handleImageChange}
//                     className="file-input"
//                   />
//                 </>
//               )}
//             </div>
//           </div>

//           <div className="form-group">
//             <label className="form-label">Content</label>

//             <CKEditor
//             editor={ClassicEditor}
//             config={{
//               toolbar: [
//                 "heading", "|",
//                 "bold", "italic", "underline", "strikethrough", "|",
//                 "link", "bulletedList", "numberedList", "|",
//                 "outdent", "indent", "|",
//                 "imageUpload", "blockQuote", "insertTable", "|",
//                 "undo", "redo"
//               ],
//               height: 500,
//               placeholder: "Write your amazing blog post here...",
//             }}
//             data={ ""}  // Edit mode ke liye pre-fill
//             onChange={(event, editor) => {
//               const data = editor.getData();  // HTML content save karo
//               setContent(data);
//             }}
//           />
//           </div>

//           <div className="form-actions">
//             <button type="submit" className="btn btn-success">
//               Add Blog
//             </button>
//           </div>
//         </form>
//       </div>
//     </Sidebar>
//   );
// }


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PhotoIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Sidebar from "../components/Sidebar";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function Form() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [pictures, setPictures] = useState([]); // Array of File objects
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Multiple images handler
  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setPictures((prev) => [...prev, ...selectedFiles]);
  };

  // Remove single image
  const removeImage = (index) => {
    setPictures((prev) => prev.filter((_, i) => i !== index));
  };

  // Submit to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      setError("Title and content are required");
      return;
    }

    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);

    // Add all pictures with the exact field name "pictures"
    pictures.forEach((file) => {
      formData.append("pictures", file);
    });

    try {
      const token = localStorage.getItem("token");

      const res = await fetch("http://localhost:8000/api/add/blog", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // DON'T set Content-Type — browser sets it automatically with boundary
        },
        body: formData,
      });

      const data = await res.json();

      if (res.ok) {
        alert("Blog created successfully! 🚀");
        navigate("/admin/blogs");
      } else {
        setError(data.message || "Failed to create blog");
      }
    } catch (err) {
      console.error("Upload error:", err);
      setError("Network error – Is backend running?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Sidebar>
      <div className="page-header">
        <h1 className="page-title">Add New Blog</h1>
      </div>

      <div className="card">
        {error && (
          <div style={{ padding: "1rem", background: "#fee2e2", color: "#991b1b", borderRadius: "8px", marginBottom: "1rem" }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Title */}
          <div className="form-group">
            <label className="form-label">Blog Title</label>
            <input
              type="text"
              className="input-text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter an awesome title..."
              required
            />
          </div>

          {/* Multiple Images */}
          <div className="form-group">
            <label className="form-label">Gallery Images (Up to 10)</label>
            <div className={`image-upload-box ${pictures.length > 0 ? "image-has-preview" : ""}`}>
              {pictures.length > 0 ? (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "1rem", padding: "1rem" }}>
                  {pictures.map((file, index) => (
                    <div key={index} style={{ position: "relative", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={`Preview ${index + 1}`}
                        style={{ width: "100%", height: "180px", objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          background: "rgba(239,68,68,0.9)",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          cursor: "pointer"
                        }}
                      >
                        <XMarkIcon style={{ width: "20px", height: "20px", margin: "auto" }} />
                      </button>
                      {index === 0 && (
                        <div style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          background: "rgba(0,0,0,0.7)",
                          color: "#86efac",
                          padding: "6px",
                          fontSize: "0.8rem",
                          textAlign: "center"
                        }}>
                          Featured Image
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <PhotoIcon className="upload-icon" />
                  <p className="upload-text">Click to upload up to 10 images</p>
                </>
              )}

              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                className="file-input"
                disabled={pictures.length >= 10}
              />
              {pictures.length >= 10 && (
                <p style={{ color: "#ef4444", fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  Maximum 10 images allowed
                </p>
              )}
            </div>
          </div>

          {/* CKEditor Content */}
          <div className="form-group">
            <label className="form-label">Content</label>
            <div style={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden" }}>
              <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "heading", "|",
                    "bold", "italic", "underline", "|",
                    "link", "bulletedList", "numberedList", "|",
                    "imageUpload", "blockQuote", "insertTable", "|",
                    "undo", "redo"
                  ],
                  image: { toolbar: ["imageTextAlternative", "imageStyle:inline", "imageStyle:block", "imageStyle:side"] },
                }}
                data={content}
                onChange={(event, editor) => {
                  setContent(editor.getData());
                }}
                onReady={(editor) => {
                  editor.editing.view.change((writer) => {
                    writer.setStyle("min-height", "500px", editor.editing.view.document.getRoot());
                  });
                }}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="form-actions">
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? "Creating Blog..." : "Publish Blog"}
            </button>
          </div>
        </form>
      </div>
    </Sidebar>
  );
}